import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'uikit/loaders';

import { useGlobalQueries } from '@/exceed';

import useEmbedChat from '../hooks/useEmbedChat';

import styles from '../styles/videoChat.module.scss';

const VideoChat = ({ chatPath = '' }) => {
  const targetRef = useRef(null);
  const { learnerSettings } = useGlobalQueries();

  const { isLoadingWidget } = useEmbedChat({
    chatPath,
    id: 'video-chat',
    targetRef,
    widgetUrl: learnerSettings.data?.tribe_chat_embed_js_url,
  });

  return (
    <div className={styles.element} ref={targetRef}>
      {isLoadingWidget && <Loading />}
    </div>
  );
};

VideoChat.propTypes = {
  chatPath: PropTypes.string,
};

export default VideoChat;
